import { Box, TextField } from "@mui/material";
import { useTranslate } from "src/locales";
import Grid from "@mui/material/Grid";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzMuiCloseButton from "src/components/core-components/mui/buttons/ByzMuiCloseButton";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { rowsGuide } from "../diet-process/rows";
type DietTypeAddProps = {
    onClose: () => void;
    selectedRow: number;
};
function DietTypeAdd({ onClose, selectedRow }: DietTypeAddProps) {
    const { t } = useTranslate();
    console.log(selectedRow);
    const selectedGuideName = rowsGuide.find(item => item.id === selectedRow)?.NAME || '';
    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "7px 17px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <Box style={{ width: "100%" }}>
                    <Grid
                        container

                        sx={{ p: 2, borderBottom: "1px solid #E0E0E0", bgcolor: "#F4F7FE" }}
                    >
                        <ByzMuiTypography >
                            {t("ration.meal")}
                        </ByzMuiTypography>

                    </Grid>

                    <Box marginTop="10px" display="flex " justifyContent="space-between"  >
                        <ByzNurseSaveButton />
                        <ByzMuiCloseButton onClick={onClose} />
                    </Box>

                </Box>
                <Box width="100%" >
                    <Grid
                        container
                        sx={{ margin: "8px", borderBottom: "1px solid #E0E0E0", marginBottom: "30px" }}
                    >
                    </Grid>
                </Box>
            </div>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "7px 17px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",

                }}
            >
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width={"100%"}
                    marginLeft="20px"
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction="row" spacing={5} alignItems="center"
                            justifyContent="space-between"
                            padding="15px">
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                sx={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",
                                    textAlign: "bottom",
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: 'flex',
                                    backgroundColor: "#F4F7FE",
                                    p: 2
                                }} >
                                <ByzMuiTypography style={{ textAlign: "center", marginLeft: "15px" }}>
                                    {t("ration.select-meal")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} >
                                <ByzMuiTextField sx={{ width: '235px', marginLeft: '16px' }} color='info' label="Seçiniz" variant="outlined" value={selectedGuideName}
                                    InputProps={{
                                        readOnly: true,
                                    }} />
                            </Grid>

                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width={"100%"}
                    marginLeft="20px"
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction="row" spacing={5} alignItems="center"
                            justifyContent="space-between"
                            padding="15px">
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                sx={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",

                                    textAlign: "bottom",
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: 'flex',
                                    backgroundColor: "#F4F7FE",
                                    p: 2
                                }} >
                                <ByzMuiTypography style={{ textAlign: "center", marginLeft: "15px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("ration.diet-type-add")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} >

                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width={"100%"}
                    marginLeft={"20px"}
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction={"row"} spacing={5} alignItems={"center"}
                            justifyContent={"space-between"}
                            width={"200%"}
                            padding={"15px"}>
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                sx={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",
                                    textAlign: "bottom",
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: 'flex',

                                    width: "800 px",
                                }} >
                                <ByzMuiTypography sx={{ textAlign: "center", marginLeft: "75px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("ration.names")} <ByzMuiTypography style={{ color: "red" }}>*</ByzMuiTypography>
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} >
                                <ByzMuiTextField sx={{ width: '235px', marginLeft: '16px' }} color='info' label="Adı" variant="outlined" />
                            </Grid>
                        </Grid>

                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width={"100%"}
                    marginLeft={"20px"}
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction={"row"} spacing={5} alignItems={"center"}
                            justifyContent={"space-between"}
                            width={"200%"}
                            padding={"15px"}>
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                sx={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",

                                    textAlign: "bottom",
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: 'flex'
                                }} >
                                <ByzMuiTypography sx={{ textAlign: "center", marginLeft: "75px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("ration.companion")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} >
                                <Grid md={12} xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ByzMuiCheckBox sx={{ width: '35px', marginLeft: '5px', height: '50px' }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width={"100%"}
                    marginLeft={"20px"}
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction={"row"} spacing={5} alignItems={"center"}
                            justifyContent={"space-between"}
                            width={"200%"}
                            padding={"15px"}>

                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                sx={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",

                                    textAlign: "bottom",
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: 'flex'
                                }} >
                                <ByzMuiTypography sx={{ textAlign: "center", marginLeft: "75px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("ration.automatic-call-snack")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} >
                                <ByzMuiSelect renderInput={(params) => <TextField {...params} variant="outlined" />} options={[]} sx={{ width: '235px', marginLeft: '16px' }} color='info' label="Adı" placeholder='Adı' />
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width={"100%"}
                    marginLeft={"20px"}
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction={"row"} spacing={5} alignItems={"center"}
                            justifyContent={"space-between"}
                            width={"200%"}
                            padding={"15px"}>
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                sx={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",
                                    textAlign: "bottom",
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: 'flex'
                                }} >
                                <ByzMuiTypography sx={{ textAlign: "center", marginLeft: "75px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("active")}?
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} sx={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                                <ByzMuiCheckBox sx={{ width: '35px', marginLeft: '5px' }} />
                            </Grid>
                        </Grid>
                    </Grid>

                </Box>
            </div>
        </>
    )
}

export default DietTypeAdd;